import { isSwitchedOn, type SectionLink } from '../lib/sections'

export type EditorialTitle = { slug: string; title: string; section: string; path: string; members?: string }

/** The four titles, in canvas order (spec §2 D2). Membership-capable titles
 *  carry their members category name. */
export const EDITORIAL_TITLES: EditorialTitle[] = [
  { slug: 'flight_journal', title: 'Flight Journal', section: 'Flight Line', path: 'flight-line', members: 'Member exclusives' },
  { slug: 'model_airplane_news', title: 'Model Airplane News', section: 'Hangar Talk', path: 'hangar-talk', members: 'Member exclusives' },
  { slug: 'rc_car_action', title: 'RC Car Action', section: 'Pit Lane', path: 'pit-lane', members: 'Member exclusives' },
  { slug: 'diecast', title: 'Die Cast X', section: 'Display Case', path: 'display-case', members: 'Member exclusives' },
]

/** What /editorial shows: titles the server lists in `sections` are open; a
 *  title the writing agent does not know yet is "not set up" for everyone
 *  (none today; all four were set up by 2026-10-14); a set-up title this person may not use is dropped (they never
 *  learn of it). An admin's `sections` is every set-up title. */
export type TitleCard = EditorialTitle & { state: 'open' | 'not_set_up' | 'no_access'; switchedOn?: boolean }

export function titleCards(sections: SectionLink[], isAdmin: boolean): TitleCard[] {
  const open = new Set(sections.map((s) => s.slug))
  const off = new Set(sections.filter((s) => !isSwitchedOn(s)).map((s) => s.slug))
  const SET_UP = new Set(['flight_journal', 'model_airplane_news', 'rc_car_action', 'diecast'])
  return EDITORIAL_TITLES.flatMap((t): TitleCard[] => {
    // Open but not switched on (outside SECTION_AGENT_PUBS): readable, nothing can be written or published.
    if (open.has(t.slug)) return [{ ...t, state: 'open' as const, switchedOn: !off.has(t.slug) }]
    if (!SET_UP.has(t.slug)) return [{ ...t, state: 'not_set_up' }]
    return isAdmin ? [{ ...t, state: 'not_set_up' }] : []
  })
}
